import { FOTOS } from "./portafolio";

/**
 * Los cuatro eventos que más se contratan, para el home.
 *
 * Es el foco del sitio: revelación de sexo, embarazo, baby shower y boda. Cada
 * uno lleva una foto del manifiesto de data/portafolio.js, por su id.
 *
 * `whatsapp` es el mensaje preescrito del botón de reserva de la tarjeta, y
 * `to` la página a la que lleva "Ver fotos". `foto` puede ir en null: la
 * tarjeta se pinta entonces sobre la textura de estudio.
 */
const fotoPorId = (id) => FOTOS.find((foto) => foto.id === id) || null;

export const MOMENTOS = [
  {
    id: "revelacion-de-sexo",
    whatsapp: "Hola Omega, quiero fotógrafo para una revelación de sexo. ¿Tienen la fecha disponible?",
    titulo: "Revelación de sexo",
    frase: "El segundo exacto en que se sabe.",
    foto: fotoPorId("familia-revelacion-nina-confeti"),
    to: "/fotografia-de-eventos",
  },
  {
    id: "embarazo",
    whatsapp: "Hola Omega, quiero fotos de embarazo. ¿Qué fechas tienen?",
    titulo: "Embarazo",
    frase: "La espera, antes de que cambie todo.",
    foto: fotoPorId("familia-embarazo-rosas"),
    to: "/fotografia-de-eventos",
  },
  {
    id: "baby-shower",
    whatsapp: "Hola Omega, quiero fotógrafo para un baby shower. ¿Tienen la fecha disponible?",
    titulo: "Baby shower",
    frase: "Los que van a estar, reunidos por primera vez.",
    foto: fotoPorId("familia-baby-shower-beso"),
    to: "/fotografia-de-eventos",
  },
  {
    id: "bodas",
    whatsapp: "Hola Omega, me caso y necesito fotógrafo para la boda. ¿Tienen la fecha disponible?",
    titulo: "Bodas",
    frase: "El sí, los anillos y el primer abrazo.",
    foto: fotoPorId("bodas-anillos"),
    to: "/fotografo-de-bodas",
  },
];

/** La foto a sangre del hero del home. */
export const FOTO_HERO = fotoPorId("eventos-revelacion-periodico");
